/**
 * Auction settle — what the auction winner posts to
 * `POST /api/auctions/[listingId]/settle` after they capture the buyer-side
 * PayPal/Stripe payment for the auction win. The server then promotes the
 * pending `seller_orders` row to settled, emits the seller notification, and
 * closes the auction. The settle path is web-only (mobile never hits it; the
 * auction-checkout UI lives only in the web app).
 *
 * Body is one field — `orderId` — pointing at the order created during the
 * winning capture. All DB-state / state-machine / auth invariants
 * (auction belongs to this user, status == "ended" not yet "settled", order
 * matches listing, deadline not expired) stay inline in `performSettle` —
 * the boundary parse is shape-only.
 *
 * @see app/api/auctions/[listingId]/settle/route.ts — handler
 * @see lib/auction-settle.ts performSettle — semantic invariants
 * @see components/detailed-listing-view/auction-winner-checkout-sheet.tsx — caller
 * @see .tondocs/payments/API_REQUEST_BOUNDARY_AUDIT.md CRITICAL-4a
 */

import { z } from "zod";
import { pinned } from "./pin";

export interface AuctionSettleRequest {
  /** `orders.id` of the row written during the winning capture. */
  orderId: string;
}

export const AuctionSettleRequestSchema = pinned<AuctionSettleRequest>()(
  z.object({
    orderId: z.string().min(1),
  }),
);
